import styled from 'styled-components';
import theme from '../../styles/defaultTheme';

export const StyledTag = styled.div`
    background: ${({ tagColor, contrastTheme }) => contrastTheme ? "transparent" :  tagColor}1A;
    border: solid 1px ${({ contrastTheme }) => contrastTheme ? "#FFFFFF" : "transparent"};
    color: ${({ tagColor }) => tagColor} !important;
    min-height: 20px;
    width: 86px;
    font-size: ${theme.font.size12};
    border-radius: 10px;
    padding: 0 15px;
    font-weight: bold;
`;
